import {
  INIT_SUMMARY_PAGE_START,
  CLEAR_ANALYTICS,
} from '../actions';

interface AnalyticsState {
  pageLoadStart?: number;
}

interface Action {
  type: string;
  payload?: unknown;
}

const initialState: AnalyticsState = {};

export const analytics = (state: AnalyticsState = initialState, { type }: Action): AnalyticsState => {
  switch (type) {
    case INIT_SUMMARY_PAGE_START:
      return {
        pageLoadStart: Date.now(),
      };
    case CLEAR_ANALYTICS:
      return {};
    default:
      return state;
  }
};
